import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../Boilerplate/BreadcrumbContext";
import BidList from "./BidList";
import BidNew from "./BidNew";
import Bid from "./Bid";
import BidConvert from "./BidConvert";

class Bids extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Bids</title>
        </Helmet>
        <Route exact path='/bids/' component={BidList}/>
        <Switch>
          <Route path='/bids/new' component={BidNew}/>
          <Route path='/bids/:bidId' component={Bid}/>
        </Switch>
      </React.Fragment>
    );
  }
}

export default withBreadcrumb({title: 'Bids', path: '/bids/'}, Bids);



// WEBPACK FOOTER //
// ./src/components/Bids/Bids.js